import React, { useEffect, useState } from "react";
import Logo from "../../Components/SVGs/Logo";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";
import "./LoginPage.css";
import { RestaurantService } from "deliziora-client-module/client-web";
import { Button, Modal } from 'antd';
import { useAuth0 } from "@auth0/auth0-react";

export default function LoginPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { user, isAuthenticated, isLoading, logout, loginWithRedirect } = useAuth0();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSubmitRecovery = (e) => {
    e.preventDefault();
    notification.open({
      message: "Email enviado",
      description: "Foi enviado uma nova password para o seu email",
      type: "success",
    });
    handleCancel();
  }

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    if (userData) {
      navigate("/home");
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted with data:", formData);
    RestaurantService.restaurantLoginByEmailPassword(
      formData.email,
      formData.password
    )
      .then((data) => {
        console.log(data.data);
        localStorage.setItem("userData", JSON.stringify(data.data));
        /* navigate("/calendar"); */
        window.location.reload()
      })
      .catch((err) => {
        console.log(err);
        notification.open({
          message: "Erro ao por os Dados",
          description: "Por favor verifique o email e password inseridos",
          type: "error",
        });
      });
  };
  return (
    <div className="container_login">
      <div className="logo_container">
        <Logo />
        <div>
          <h1>Telabite</h1>
        </div>
      </div>
      <div className="input_container">
        <div>
          {/* <form className="input_box" onSubmit={handleSubmit}>
            <input
              type="text"
              className="input_item"
              placeholder="Nome de Utilizador"
              name="email"
              onChange={handleInputChange}
            />
            <input
              type="password"
              className="input_item"
              placeholder="Password"
              name="password"
              onChange={handleInputChange}
            />
            <input type="submit" value="Login" className="input_submit" />
            <button
              style={{
                backgroundColor: "white",
                color: "#F36528",
              }}
              className="input_submit"
              type="button"
              onClick={() => showModal()}
            >
              Recuperar Password
            </button>
          </form> */}
          <Button
            onClick={() => {
              loginWithRedirect({
                appState: {
                  // returnTo: `${window.location.origin}/create-restaurant-oauth/${uuid}${searchParams}`,
                },
                authorizationParams: {
                  redirect_uri: `${window.location.origin}/create-restaurant-callback-login`,
                }
              });
            }}
            style={{
              backgroundColor: "#F36528",
              color: "white",
              width: "100%",
              height: "50px",
              marginBottom: "10px",
              marginTop: "10px",
              marginBottom: "10px",
            }}>
            Login
          </Button>
          <Button
            onClick={() => logout({
              logoutParams: {
                returnTo: window.location.origin,
              },
              openUrl: (url) => {
                window.location.href = url;
              }
            })}
            style={{
              backgroundColor: "white",
              color: "#F36528",
              width: "100%",
              height: "50px",
              marginBottom: "10px",
              marginTop: "10px",
              marginBottom: "10px",
            }}>
            Logout
          </Button>
          {/* {
            isAuthenticated && (
              <Button
                onClick={() => logout({
                  logoutParams: {
                    returnTo: window.location.origin,
                  },
                  openUrl: (url) => {
                    window.location.href = url;
                  }
                })}
                style={{
                  backgroundColor: "white",
                  color: "#F36528",
                  width: "100%",
                  height: "50px",
                  marginBottom: "10px",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}>
                Logout
              </Button>
            )
          } */}
          <Modal title="Recuperar senha" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} okButtonProps={{ style: { display: 'none' } }}>
            <form className="input_box" onSubmit={handleSubmitRecovery}>
              <input type="email" placeholder="Email" className="input_item" />
              <input type="submit" value="Enviar" className="input_submit" />
            </form>
          </Modal>
        </div>
      </div>
    </div>
  );
}
